import { Button, FormControl, FormLabel, Switch } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";
import type { SendEmailForm } from "../models/send-invoice-form";

type SendEmailToggleProps = {
  form: SendEmailForm | undefined;
  label: ReactNode;
  isEditable: boolean;
  isPlanLocked: boolean;
  switchId: string;
  minW?: string;
  onEnable?: () => void;
};

export const SendEmailToggle = observer(function SendEmailToggle({
  form,
  label,
  isEditable,
  isPlanLocked,
  switchId,
  minW,
  onEnable,
}: SendEmailToggleProps) {
  if (!form) return null;

  return (
    <FormControl
      alignItems="center"
      display="flex"
      minW={minW}
      isInvalid={form.formHasError}
    >
      <Switch
        id={switchId}
        isChecked={form.sendEmail.value}
        isDisabled={!isEditable}
        onChange={({ target }) => {
          if (target.checked) {
            onEnable?.();
          }
          form.handleSwitchToggle(target.checked);
          form.resetToTemplate();
        }}
      />
      <FormLabel
        mb="0"
        color={form.formHasError ? "red" : undefined}
        htmlFor={switchId}
        marginInlineStart="1"
      >
        {label}
        &nbsp;
        {form.sendEmail.value && (
          <Button
            onClick={(e) => {
              e.stopPropagation();
              form.modalState.onOpen();
            }}
            size="sm"
            variant="link"
          >
            {isPlanLocked ? <Trans>(show)</Trans> : <Trans>(edit)</Trans>}
          </Button>
        )}
      </FormLabel>
    </FormControl>
  );
});
